module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group select2-plugin"
  }, [_c('select', {
    ref: "slEmpleado",
    staticClass: "form-control select2",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione un empleado")]), _vm._v(" "), _vm._l((_vm.usuariosProcesado), function(oUser) {
    return _c('option', {
      key: oUser._id,
      domProps: {
        "value": oUser._id
      }
    }, [_vm._v(_vm._s(oUser.displayName) + " "), (oUser.tienePedidosFecha) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("tiene pedidos")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selectEmpleado($event)
      }
    }
  }, [_vm._v("OK")])])]), _vm._v(" "), _c('span', {
    staticClass: "label label-danger",
    class: {
      hide: !_vm.mostrarMensaje
    }
  }, [_vm._v("Debe seleccionar un empleado")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7914afa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/EmpleadosEmpresa.vue
// module id = 1168
// module chunks = 5